import React, { useEffect, useRef } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import '../css/ThankYouPage.css';
import MetaHelper from '../MetaHelper';

const ThankYouPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Default values if state is missing
    const project = location.state?.project || "Elite Gated Communities";
    const returnPath = location.state?.returnPath || "/"; 

    // Google Ads conversion for CPR Cosmos leads - fires only on /cpr-cosmos/thank-you,
    // once per lead. The lead ID is created by the Cosmos form on successful submit and
    // a sessionStorage flag keeps it from re-firing on remount, refresh or back/forward.
    const conversionFired = useRef(false);
    useEffect(() => {
        if (location.pathname !== '/cpr-cosmos/thank-you') return;
        if (conversionFired.current || !window.gtag) return;
        try {
            const leadId = sessionStorage.getItem('cosmos_lead_id');
            if (!leadId) return;
            const sentKey = `conversion_sent_${leadId}`;
            if (sessionStorage.getItem(sentKey)) return;
            sessionStorage.setItem(sentKey, '1');
            conversionFired.current = true;
            window.gtag('event', 'conversion', {
                'send_to': 'AW-17973722004/s7ZmCPaOrPgcEJT3xPpC',
                'transaction_id': leadId
            });
        } catch (err) { /* storage unavailable - skip rather than risk a duplicate */ }
    }, [location.pathname]);

    return (
        <div className="thank-you-wrapper">
            <MetaHelper 
                title={`Thank You | ${project} | CPR Constructions`} 
                description={`Thank you for inquiring about ${project} by CPR Constructions, the leading developer of premium gated communities in Tirupati.`}
            />

            <Container className="d-flex justify-content-center">
                <motion.div 
                    initial={{ opacity: 0, y: 20 }} 
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="thank-you-card shadow-lg"
                >
                    <div className="success-icon-circle">
                        <FontAwesomeIcon icon={faCheck} />
                    </div>

                    <h1 className="thank-you-title">Thank You!</h1>
                    
                    <p className="thank-you-text">
                        We have received your inquiry for <strong>{project}</strong>. 
                        <strong> CPR Constructions</strong> is proud to develop the finest 
                        <strong> gated communities in Tirupati</strong>, and our team will 
                        connect with you shortly to assist you further.
                    </p>

                    <Button 
                        className="back-btn shadow"
                        onClick={() => navigate(returnPath)}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                        BACK TO {returnPath === '/' ? 'HOME' : 'PROJECT'}
                    </Button>

                    <div className="mt-4 pt-3 border-top border-light">
                        <small className="text-muted" style={{fontSize: '0.75rem', letterSpacing: '0.5px'}}>
                            © 2026 CPR Constructions | Premium Real Estate Tirupati
                        </small>
                    </div>
                </motion.div>
            </Container>
        </div>
    );
};

export default ThankYouPage;